<script lang="ts">
    import type { Blog } from "$lib/datamodel";
    import * as Card from "$lib/components/ui/card";
    export let related: Promise<Partial<Blog>[]>;
</script>

<aside>
    <div class="font-bold text-2xl antialiased tracking-tight">
      <slot name="header">
      </slot>
    </div>
    <ul>
      {#await related}
        {#each (new Array(6)) as pl}
          <Card.Root class="border-none rounded-none shadow-none">
            <Card.Header class="p-0 pb-2">
              <div class="animate-pulse bg-nucamp-light rounded-none md:rounded-lg shadow-nucamp-sm h-48 w-full"></div>
            </Card.Header>
            <Card.Content class="p-0 pb-6">
              <div class="animate-pulse bg-nucamp-light rounded-none md:rounded-lg shadow-nucamp-sm h-6 w-4/5"></div>
            </Card.Content>
          </Card.Root>
        {/each}
      {:then relatedBlogs}
        {#each relatedBlogs as blog}
          <a href={`/blog/${blog.shortid}`}>
            <Card.Root class="border-none rounded-none shadow-none">
              <Card.Header class="p-0 pb-2">
                <img class="rounded-none md:rounded-lg shadow-nucamp-sm" loading="lazy" src={blog.media?.list[0].url} alt={blog.metaimagealt} />
              </Card.Header>
              <Card.Content class="p-0 pb-6">
                <Card.Title class="text-nucamp-light hover:text-nucamp-light-hover hover:underline underline-offset-2 decoration-dotted leading-5">{blog.h1}</Card.Title>
              </Card.Content>
            </Card.Root>
          </a>
        {/each}
      {/await}
    </ul>
</aside>